const defaultFooter = {
    footerTitle: 'Ready to get started?',
    footerDescription: 'Talk to us today',
    footerButton: 'Schedule my free pilot!',
    footerButtonLink: '/free-trial',
    footerButtonIsExternal: false,
}

const state = {
    ...defaultFooter,
}

const getters = {
    footerTitle: state => state.footerTitle,
    footerDescription: state => state.footerDescription,
    footerButton: state => state.footerButton,
    footerButtonLink: state => state.footerButtonLink,
    footerButtonIsExternal: state => state.footerButtonIsExternal,
}

const actions = {
    updateFooter: ({ commit, dispatch }, footerNew) => {
        const finalFooter = {...defaultFooter, ...footerNew};

        commit('setFooterTitle', finalFooter.footerTitle);
        commit('setFooterDescription', finalFooter.footerDescription);
        commit('setFooterButton', finalFooter.footerButton);
        commit('setFooterButtonLink', finalFooter.footerButtonLink);
        commit('setFooterButtonIsExternal', finalFooter.footerButtonIsExternal);
    },
    resetFooter: ({ commit, dispatch }) => {
        commit('setFooterTitle', defaultFooter.footerTitle);
        commit('setFooterDescription', defaultFooter.footerDescription);
        commit('setFooterButton', defaultFooter.footerButton);
        commit('setFooterButtonLink', defaultFooter.footerButtonLink);
        commit('setFooterButtonIsExternal', defaultFooter.footerButtonIsExternal);
    },
}

const mutations = {
    setFooterTitle: (state, footerTitle) => state.footerTitle = footerTitle,
    setFooterDescription: (state, footerDescription) => state.footerDescription = footerDescription,
    setFooterButton: (state, footerButton) => state.footerButton = footerButton,
    setFooterButtonLink: (state, footerButtonLink) => state.footerButtonLink = footerButtonLink,
    setFooterButtonIsExternal: (state, footerButtonIsExternal) => state.footerButtonIsExternal = footerButtonIsExternal,
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
